// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VendorStaffScreen_pageHeader__d4fG3 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid var(--border);
  margin-bottom: 16px;
}
.VendorStaffScreen_pageHeader__d4fG3 h1 {
  font: var(--h3);
  font-weight: 700;
  color: var(--primary-Text);
  font-family: var(--font-bodoni-72);
}
.VendorStaffScreen_pageHeader__d4fG3 .VendorStaffScreen_left__XoLaG {
  display: flex;
  align-items: center;
  gap: 12px;
}
.VendorStaffScreen_pageHeader__d4fG3 .VendorStaffScreen_right__uC0Rc {
  display: flex;
  align-items: center;
  gap: 20px;
}
.VendorStaffScreen_pageHeader__d4fG3 .VendorStaffScreen_right__uC0Rc .VendorStaffScreen_date__SbXm7 {
  display: flex;
  align-items: center;
  gap: 4px;
}
.VendorStaffScreen_pageHeader__d4fG3 .VendorStaffScreen_right__uC0Rc .VendorStaffScreen_date__SbXm7 img,
.VendorStaffScreen_pageHeader__d4fG3 .VendorStaffScreen_right__uC0Rc .VendorStaffScreen_date__SbXm7 svg {
  width: 16px;
  height: 16px;
  object-fit: scale-down;
  display: block;
}
.VendorStaffScreen_pageHeader__d4fG3 .VendorStaffScreen_right__uC0Rc .VendorStaffScreen_date__SbXm7 span {
  font: var(--body-font-four);
  color: var(--primary-Text);
  display: block;
}

.VendorStaffScreen_pageMain__QXZ9O {
  padding: 0 24px;
  overflow-x: hidden;
}

.VendorStaffScreen_metricCardsWrp__wYQY0 {
  margin-bottom: 20px;
}

.VendorStaffScreen_staffCardsWrp__tlwXc {
  margin-top: 24px;
}

.VendorStaffScreen_schedulerWrap__zIiMc {
  margin-top: 24px;
}

.VendorStaffScreen_taskList__kASeB {
  display: flex;
  flex-direction: column;
  gap: 8px;
  list-style: none;
}
.VendorStaffScreen_taskList__kASeB li {
  display: flex;
  align-items: center;
  padding: 7.5px;
  border-radius: 8px;
  border: 1px solid var(--border);
}

@media (max-width: 767px) {
  .VendorStaffScreen_pageHeader__d4fG3 {
    padding: 15px;
  }
  .VendorStaffScreen_pageMain__QXZ9O {
    padding: 0 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/UserDashboard/VendorStaffScreen/index.module.scss"],"names":[],"mappings":"AACA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,sCAAA;EACA,mBAAA;AAAD;AAEC;EACC,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kCAAA;AAAF;AAGC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AADF;AAIC;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AAFF;AAIE;EACC,aAAA;EACA,mBAAA;EACA,QAAA;AAFH;AAIG;;EAEC,WAAA;EACA,YAAA;EACA,sBAAA;EACA,cAAA;AAFJ;AAKG;EACC,2BAAA;EACA,0BAAA;EACA,cAAA;AAHJ;;AASA;EACC,eAAA;EACA,kBAAA;AAND;;AASA;EACC,mBAAA;AAND;;AASA;EACC,gBAAA;AAND;;AASA;EACC,gBAAA;AAND;;AASA;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AAND;AAQC;EACC,aAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,+BAAA;AANF;;AAWA;EACC;IACC,aAAA;EARA;EAWD;IACC,eAAA;EATA;AACF","sourcesContent":["\r\n.pageHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 16px 24px;\r\n\tborder-bottom: 1px solid var(--border);\r\n\tmargin-bottom: 16px;\r\n\r\n\th1 {\r\n\t\tfont: var(--h3);\r\n\t\tfont-weight: 700;\r\n\t\tcolor: var(--primary-Text);\r\n\t\tfont-family: var(--font-bodoni-72);\r\n\t}\r\n\r\n\t.left {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 12px;\r\n\t}\r\n\r\n\t.right {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tgap: 20px;\r\n\r\n\t\t.date {\r\n\t\t\tdisplay: flex;\r\n\t\t\talign-items: center;\r\n\t\t\tgap: 4px;\r\n\r\n\t\t\timg,\r\n\t\t\tsvg {\r\n\t\t\t\twidth: 16px;\r\n\t\t\t\theight: 16px;\r\n\t\t\t\tobject-fit: scale-down;\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\tfont: var(--body-font-four);\r\n\t\t\t\tcolor: var(--primary-Text);\r\n\t\t\t\tdisplay: block;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.pageMain {\r\n\tpadding: 0 24px;\r\n\toverflow-x: hidden;\r\n}\r\n\r\n.metricCardsWrp {\r\n\tmargin-bottom: 20px;\r\n}\r\n\r\n.staffCardsWrp {\r\n\tmargin-top: 24px;\r\n}\r\n\r\n.schedulerWrap {\r\n\tmargin-top: 24px;\r\n}\r\n\r\n.taskList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 8px;\r\n\tlist-style: none;\r\n\r\n\tli {\r\n\t\tdisplay: flex;\r\n\t\talign-items: center;\r\n\t\tpadding: 7.5px;\r\n\t\tborder-radius: 8px;\r\n\t\tborder: 1px solid var(--border);\r\n\t}\r\n}\r\n\r\n\r\n@media (max-width: 767px) {\r\n\t.pageHeader {\r\n\t\tpadding: 15px;\r\n\t}\r\n\r\n\t.pageMain {\r\n\t\tpadding: 0 15px;\r\n\t}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageHeader": `VendorStaffScreen_pageHeader__d4fG3`,
	"left": `VendorStaffScreen_left__XoLaG`,
	"right": `VendorStaffScreen_right__uC0Rc`,
	"date": `VendorStaffScreen_date__SbXm7`,
	"pageMain": `VendorStaffScreen_pageMain__QXZ9O`,
	"metricCardsWrp": `VendorStaffScreen_metricCardsWrp__wYQY0`,
	"staffCardsWrp": `VendorStaffScreen_staffCardsWrp__tlwXc`,
	"schedulerWrap": `VendorStaffScreen_schedulerWrap__zIiMc`,
	"taskList": `VendorStaffScreen_taskList__kASeB`
};
export default ___CSS_LOADER_EXPORT___;
